/* assets/rgd-upsell-bestseller.js */
(function () {
  if (window.__RGD_UPSELL_BESTSELLER_JS__) return;
  window.__RGD_UPSELL_BESTSELLER_JS__ = true;

  var DEBUG = false;
  function log(){ if (!DEBUG) return; try { console.log.apply(console, arguments); } catch(e){} }
  function warn(){ try { console.warn.apply(console, arguments); } catch(e){} }

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function sleep(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }

  function formatMoneyFromShopify(cents){
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify.money_format) || 'R$ {{amount_with_comma_separator}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch(e){}
    var v = (Number(cents || 0) / 100);
    return v.toLocaleString('pt-BR', { style:'currency', currency:'BRL' });
  }

  function escapeHtml(s){
    return String(s || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  // =========================
  // UPSell UI
  // =========================
  function getStep(root){
    var track = qs('[data-rgd-track]', root);
    var slide = track ? qs('[data-rgd-slide]', track) : null;
    if (!slide) return 280;

    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.gap || style.columnGap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateArrows(root){
    var viewport = qs('[data-rgd-viewport]', root);
    if (!viewport) return;

    var prevBtn = qs('[data-rgd-arrow="prev"]', root);
    var nextBtn = qs('[data-rgd-arrow="next"]', root);

    var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var x = viewport.scrollLeft;

    var atStart = x <= 2;
    var atEnd = x >= (max - 2);

    if (prevBtn) prevBtn.disabled = (max <= 2) ? true : atStart;
    if (nextBtn) nextBtn.disabled = (max <= 2) ? true : atEnd;

    var nav = qs('[data-rgd-nav]', root);
    if (nav) nav.style.display = (max <= 2 ? 'none' : 'flex');
  }

  function initVariantSelect(root){
    qsa('[data-rgd-variants]', root).forEach(function(group){
      if (group.dataset.rgdVariantsInited === '1') return;
      group.dataset.rgdVariantsInited = '1';

      var select = qs('[data-rgd-variant-select]', group);
      if (!select) return;

      function apply(variantId){
        var slide = group.closest('[data-rgd-slide]');
        var addBtn = slide ? qs('[data-rgd-add]', slide) : null;
        if (addBtn && variantId) addBtn.setAttribute('data-variant-id', String(variantId));
      }

      apply(select.value);
      select.addEventListener('change', function(){ apply(select.value); });
    });
  }

  function bindDrag(root){
    var viewport = qs('[data-rgd-viewport]', root);
    if (!viewport) return;
    if (viewport.dataset.rgdDragBound === '1') return;
    viewport.dataset.rgdDragBound = '1';

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;

    viewport.addEventListener('mousedown', function(e){
      if (e.button !== 0) return;
      if (e.target.closest('a, button, input, select, textarea, label')) return;

      isDown = true;
      viewport.classList.add('is-dragging');
      startX = e.pageX;
      startScrollLeft = viewport.scrollLeft;
    });

    viewport.addEventListener('contextmenu', function(){
      isDown = false;
      viewport.classList.remove('is-dragging');
    });

    window.addEventListener('mouseup', function(){
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      updateArrows(root);
    });

    viewport.addEventListener('mouseleave', function(){
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('is-dragging');
      updateArrows(root);
    });

    viewport.addEventListener('mousemove', function(e){
      if (!isDown) return;

      if (e.buttons !== undefined && (e.buttons & 1) !== 1) {
        isDown = false;
        viewport.classList.remove('is-dragging');
        return;
      }

      e.preventDefault();
      var dx = e.pageX - startX;
      viewport.scrollLeft = startScrollLeft - dx;
    });
  }

  function initUpsellUI(){
    qsa('[data-rgd-upsell]').forEach(function(root){
      bindDrag(root);
      initVariantSelect(root);
      updateArrows(root);
    });
  }

  window.RGD_UpsellBestseller_init = function(){
    initUpsellUI();
  };

  // setas do upsell (delegation)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-rgd-arrow]');
    if (!btn) return;
    var root = btn.closest('[data-rgd-upsell]');
    if (!root) return;

    var viewport = qs('[data-rgd-viewport]', root);
    if (!viewport) return;

    var dir = btn.getAttribute('data-rgd-arrow') === 'prev' ? -1 : 1;
    viewport.scrollBy({ left: dir * getStep(root), behavior: 'smooth' });
    setTimeout(function(){ updateArrows(root); }, 180);
  });

  // atualiza setas quando rolar o viewport
  document.addEventListener('scroll', function(e){
    var vp = e.target && e.target.matches && e.target.matches('[data-rgd-viewport]') ? e.target : null;
    if (!vp) return;
    var root = vp.closest('[data-rgd-upsell]');
    if (root) updateArrows(root);
  }, true);

  // =========================
  // CART (rebuild drawer__scrollable via /cart.js)
  // =========================
  function getCartDrawerRoot(){
    return qs('#CartDrawer') || qs('.drawer') || null;
  }

  function getScrollable(){
    var root = getCartDrawerRoot();
    if (!root) return null;
    return qs('.drawer__scrollable', root);
  }

  function getSubtotalEl(){
    var root = getCartDrawerRoot();
    if (!root) return null;
    var footer = qs('.drawer__footer', root);
    if (!footer) return null;
    var prices = qsa('.ajaxcart__price', footer);
    return prices.length ? prices[prices.length - 1] : null;
  }

  async function fetchCartJSON(){
    var res = await fetch('/cart.js?rgd_t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!res.ok) throw new Error('Falha em /cart.js (HTTP ' + res.status + ')');
    return await res.json();
  }

  function buildItemHTML(item, idx){
    var url = item.url || ('/products/' + (item.handle || ''));
    var img = item.image ? String(item.image) : '';

    // tenta aproximar _180x
    if (img) img = img.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_180x$1$3');

    var title = item.product_title || item.title || 'Produto';
    var line = item.key;
    var qty = item.quantity || 1;
    var price = (item.final_line_price != null) ? item.final_line_price : (item.line_price != null ? item.line_price : 0);
    var appearDelay = 3 + (idx * 2);

    // ✅ IMPORTANTE: SVG fora do icon__fallback-text (senão o CSS esconde)
    var svgMinus = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>';
    var svgPlus  = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>';

    return ''
    + '<div class="ajaxcart__product appear-animation appear-delay-' + appearDelay + '" data-rgd-line="' + escapeHtml(line) + '">'
    + '  <div class="ajaxcart__row">'
    + '    <div class="grid">'
    + '      <div class="grid__item one-third">'
    + '        <a href="' + escapeHtml(url) + '" class="ajaxcart__product-image">'
    +           (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '">' : '')
    + '        </a>'
    + '      </div>'
    + '      <div class="grid__item two-thirds">'
    + '        <div class="ajaxcart__product-name--wrapper">'
    + '          <a href="' + escapeHtml(url) + '" class="ajaxcart__product-name">' + escapeHtml(title) + '</a>'
    + '        </div>'
    + '        <div class="grid grid--full display-table">'
    + '          <div class="grid__item display-table-cell one-half">'
    + '            <div class="ajaxcart__quantity">'
    + '              <label class="visually-hidden">Quantidade</label>'
    + '              <div class="js-qty__wrapper">'
    + '                <input type="text" class="js-qty__num" value="' + qty + '"'
    + '                  data-rgd-line="' + escapeHtml(line) + '"'
    + '                  min="0" aria-label="quantity" pattern="[0-9]*">'
    + '                <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduzir quantidade em uma unidade" data-rgd-qty="minus" data-rgd-line="' + escapeHtml(line) + '">'
    +                    svgMinus
    + '                  <span class="icon__fallback-text" aria-hidden="true">−</span>'
    + '                </button>'
    + '                <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Aumentar quantidade em uma unidade" data-rgd-qty="plus" data-rgd-line="' + escapeHtml(line) + '">'
    +                    svgPlus
    + '                  <span class="icon__fallback-text" aria-hidden="true">+</span>'
    + '                </button>'
    + '              </div>'
    + '            </div>'
    + '          </div>'
    + '          <div class="grid__item display-table-cell one-half text-right">'
    + '            <span class="ajaxcart__price">' + escapeHtml(formatMoneyFromShopify(price)) + '</span>'
    + '          </div>'
    + '        </div>'
    + '        <div class="grid grid--full display-table"></div>'
    + '      </div>'
    + '    </div>'
    + '  </div>'
    + '</div>';
  }

  function rebuildScrollableFromCart(cart){
    var scrollable = getScrollable();
    if (!scrollable) throw new Error('Não encontrei .drawer__scrollable dentro do drawer.');

    var items = cart && cart.items ? cart.items : [];
    var html = '';
    for (var i = 0; i < items.length; i++){
      html += buildItemHTML(items[i], i);
    }
    scrollable.innerHTML = html;
  }

  function updateSubtotalFromCart(cart){
    var el = getSubtotalEl();
    if (!el) return;
    el.textContent = formatMoneyFromShopify(cart.total_price || 0);
  }

  async function changeLineQuantity(lineKey, newQty){
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(newQty || 0)) })
    });
    if (!res.ok) throw new Error('Falha ao atualizar quantidade.');
    return await res.json().catch(function(){ return null; });
  }

  function bindQtyControls(){
    if (document.documentElement.dataset.rgdQtyBound === '1') return;
    document.documentElement.dataset.rgdQtyBound = '1';

    document.addEventListener('click', async function(e){
      var btn = e.target.closest('[data-rgd-qty]');
      if (!btn) return;

      var line = btn.getAttribute('data-rgd-line');
      if (!line) return;

      var root = btn.closest('[data-rgd-line]');
      var input = root ? qs('.js-qty__num', root) : null;
      var cur = input ? Number(input.value || 1) : 1;

      var dir = btn.getAttribute('data-rgd-qty');
      var next = dir === 'plus' ? (cur + 1) : (cur - 1);

      if (input) input.value = String(Math.max(0, next));

      try {
        btn.disabled = true;
        var cart = await changeLineQuantity(line, next);
        if (!cart) cart = await fetchCartJSON();

        rebuildScrollableFromCart(cart);
        updateSubtotalFromCart(cart);

        // re-render do upsell
        try { if (window.RGD_CartUpsell_refresh) window.RGD_CartUpsell_refresh('qty-change'); } catch(e2){}

        // depois de re-render, re-init UI do upsell (setas/drag)
        setTimeout(initUpsellUI, 50);
      } catch(err){
        warn(err);
        alert(err && err.message ? err.message : 'Erro ao atualizar quantidade.');
      } finally {
        btn.disabled = false;
      }
    });
  }

  async function addToCart(variantId){
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) {
      var msg = 'Não foi possível adicionar.';
      try {
        var data = await res.json();
        if (data && data.description) msg = data.description;
      } catch(e){}
      throw new Error(msg);
    }

    try { await res.json(); } catch(e){}
  }

  // add do upsell
  document.addEventListener('click', async function(e){
    var btn = e.target.closest('[data-rgd-add]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';

    var oldText = btn.textContent;
    btn.textContent = 'Adicionando...';
    btn.disabled = true;

    try {
      await addToCart(variantId);

      await sleep(180);
      var cart = await fetchCartJSON();

      rebuildScrollableFromCart(cart);
      updateSubtotalFromCart(cart);

      try { if (window.RGD_CartUpsell_refresh) window.RGD_CartUpsell_refresh('after-add'); } catch(e2){}

      // ✅ garante que setas/drag continuam
      setTimeout(initUpsellUI, 50);
      setTimeout(initUpsellUI, 300);

      btn.textContent = 'Adicionado ✓';
      setTimeout(function(){
        btn.textContent = oldText;
        btn.disabled = false;
        btn.dataset.loading = '0';
      }, 900);
    } catch(err){
      warn(err);
      alert(err && err.message ? err.message : 'Erro ao adicionar.');
      btn.textContent = oldText;
      btn.disabled = false;
      btn.dataset.loading = '0';
    }
  });

  // boot
  bindQtyControls();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      initUpsellUI();
    });
  } else {
    initUpsellUI();
  }
})();
